import howlerIntegration from 'utils/howlerIntegration';

const UPDATE_DEBOUNCE_MS = 300;

let soundEnabled = false;
export function setSoundsEnabled(enabled) {
  if (soundEnabled !== enabled) {
    soundEnabled = enabled;
    scheduleUpdate();
  }
}

// [{ ref: componentObjectRef, priority: 1, options: { src: "soundName", ...} }, ...]
const references = [];
export function addMusicReference(data) {
  const index = references.findIndex(r => r.ref === data.ref);
  if (index === -1) {
    references.push(data);
  } else {
    references[index] = data;
  }
  scheduleUpdate();
}

export function removeMusicReference(ref) {
  const index = references.findIndex(r => r.ref === ref);
  if (index !== -1) {
    references.splice(index, 1);
    scheduleUpdate();
  }
}

let updateTimeout = null;
function scheduleUpdate() {
  clearTimeout(updateTimeout);
  updateTimeout = setTimeout(checkForUpdate, UPDATE_DEBOUNCE_MS);
}

let playingSoundName = null;
function checkForUpdate() {
  clearTimeout(updateTimeout);
  updateTimeout = null;

  let activeRef = null;
  if (soundEnabled) {
    references.forEach(r => {
      if (!activeRef || r.priority > activeRef.priority) {
        activeRef = r;
      }
    });
  }

  if (activeRef && activeRef.options && activeRef.options.src) {
    const soundName = String(
      Array.isArray(activeRef.options.src)
        ? activeRef.options.src[0]
        : activeRef.options.src
    );
    if (playingSoundName !== soundName) {
      if (playingSoundName) {
        howlerIntegration.fadeOutAndStop(playingSoundName);
        playingSoundName = null;
      }

      if (!howlerIntegration.isSoundAdded(soundName)) {
        const options = {
          ...activeRef.options,
          onload: checkForUpdate
        };
        howlerIntegration.addSound(soundName, options, false);
      } else if (howlerIntegration.isSoundLoaded(soundName)) {
        const spriteName =
          activeRef.options.sprite && activeRef.options.sprite.loop
            ? 'loop'
            : undefined;
        playingSoundName = soundName;
        howlerIntegration.fadeIn(soundName);
        howlerIntegration.play(soundName, spriteName, true);
      }
    }
  } else if (playingSoundName) {
    howlerIntegration.fadeOutAndStop(playingSoundName);
    playingSoundName = null;
  }
}
